import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Grid } from "@material-ui/core";
import "../dialog-delete-domain/dialog-delete-domain.css";

const CustomDeletePermissionTitleBar = (props) => {
  const { t } = useTranslation();
  return (
    <div className="dialogDeleteDomain-title">
      <span>{t("dialogDeletePermission.titleDeletePermission")}</span>
    </div>
  );
};

const DialogDeletePermissionPure = (props) => {
  const { t } = useTranslation();

  return (
    <Dialog title={<CustomDeletePermissionTitleBar />}>
      <div className="k-form">
        <div style={{ marginBottom: "14px" }}>
          <Grid container>
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <p className="dialogDeleteDomain-text">
                ¿{t("dialogDeletePermission.AreYouShureToDelete")} {" "}
                <span style={{ fontWeight: 600 }}>
                  {props.selectedPermission?.name}
                </span>
                ?
              </p>
            </Grid>
          </Grid>
        </div>
        <div className="dialogDeleteDomain-btns-delete-container">
          <button
            className="dialogDeleteDomain-cancel-domain"
            onClick={() => props.toggleDialogDeletePermission(false)}
          >
            {t("button.cancel")}
          </button>
          <button
            className="dialogDeleteDomain-accept-domain"
            type="submit"
            onClick={() => props.deletePermission(props.selectedPermission)}
          >
            {t("button.accept")}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export { DialogDeletePermissionPure as default };
